import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './fonts/Product-Sans-Regular.ttf';
import './fonts/Product-Sans-Bold.ttf';
import {  DAppProvider } from '@usedapp/core'
import ReactGA from 'react-ga';
ReactGA.initialize('UA-210321266-2');

ReactDOM.render(
  <div className="bg-page">
    <BrowserRouter>
      <DAppProvider config={{}}>
        <App />
      </DAppProvider>
    </BrowserRouter>
  </div>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
